import React from 'react';
import styled from 'styled-components';

import { Card, CardContent } from '@/components/ui/card';
import { Title, VerticalLayout } from 'widgets';

import { LoginStatus } from './LoginStatus';
import { ResetPassword } from './ResetPassword';

export const PersonToolsTab = () => {
    return (
        <VerticalLayout $gap={16}>
            <Title section>Tools</Title>
            <ToolsWrapper>
                <Card>
                    <CardContent>
                        <ResetPassword />
                    </CardContent>
                </Card>

                <Card>
                    <CardContent>
                        <LoginStatus />
                    </CardContent>
                </Card>
            </ToolsWrapper>
        </VerticalLayout>
    );
};

const ToolsWrapper = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 32px;
`;
